import {Component, Input, ViewChild} from '@angular/core';
import {WizardStepComponent} from '../../wizard-step-component.interface';
import {NameDetailsFormComponent, NameFormData} from '../../../../../shared/name-details-form/name-details-form.component';

export type NameStepData = NameFormData;

@Component({
  selector: 'app-name-step',
  standalone: true,
  imports: [NameDetailsFormComponent],
  templateUrl: './name-step.component.html',
})
export class NameStepComponent implements WizardStepComponent {

  @Input() initialData: NameStepData | null;

  @ViewChild(NameDetailsFormComponent) private nameForm: NameDetailsFormComponent;

  isValid(): boolean {
    return this.nameForm.isValid();
  }

  getValue(): NameStepData {
    return this.nameForm.getFormValue();
  }
}
